export type ValueOf<T> = T[keyof T];
export const type = <T>(val: any) => val as T;
